import { ElMessage } from 'element-plus'

const tools = {
    // 设置cookie
    setCookie: function(c_name, value, expiredays=1) {
        var exdate = new Date()
        exdate.setDate(exdate.getDate() + expiredays)
        document.cookie =
        c_name +
        "=" +
        escape(value) +
        (expiredays == null ? "" : ";expires=" + exdate.toGMTString()) + ' ;domain=' + location.host + ';path=/'
    },
    // 获取cookie
    getCookie: function(cname) {
        var name = cname + "=";
        // var decodedCookie = decodeURIComponent(document.cookie);
        var decodedCookie = document.cookie
        var ca = decodedCookie.split(';');
        for(var i = 0; i <ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
             }
             if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
             }
         }
        return "";
    },
    // 删除cookie
    delCookie: function(cname) {
        tools.setCookie(cname,'',-1)
    },
    // 获取url参数
    getUrlParams: function() {
        const url = window.location.href;
        // 判断是否有参数
        if (url.indexOf("?") === -1) {
        return {};
        }
        const params = url.split("?")[1];
        const paramsArr = params.split("&");
        const paramsObj = {};
        paramsArr.forEach((item) => {
        const key = item.split("=")[0];
        const value = item.split("=")[1];
        // 解析中文
        paramsObj[key] = decodeURI(value);
        });
        return paramsObj;
    },
    // 生成一个包含大写字母、小写字母和数字的随机字符串
    generateString:function(length) {
        var result = '';
        var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        var hasUppercase = false;
        var hasLowercase = false;
        var hasNumber = false;
        while (result.length < length || !hasUppercase || !hasLowercase || !hasNumber) {
            var randomChar = characters.charAt(Math.floor(Math.random() * charactersLength));
            if (/[A-Z]/.test(randomChar)) {
                hasUppercase = true;
            } else if (/[a-z]/.test(randomChar)) {
                hasLowercase = true;
            } else if (/[0-9]/.test(randomChar)) {
                hasNumber = true;
            }
            result += randomChar;
            if(result.length >= 8) {
                if(!hasUppercase || !hasLowercase || !hasNumber) {
                    result = ''
                }
            }
        }
        return result;
    },
    // 复制文本 
    copyText:async function(textToCopy) {
        try {
            await navigator.clipboard.writeText(textToCopy)
            ElMessage.success(window.lang.tools1)
        } catch (error) {
            ElMessage.error(window.lang.tools2, error)
        }
    },
    // 创建文件并下载
    writeFile:function(content,filename) {
        // content下载的内容 filename生成的文件名称
        const blob = new Blob([content], { type: 'text/plain' }) // 创建一个Blob对象，‌设置内容类型为纯文本
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob) // 为Blob对象生成一个链接
        link.download = filename; // 设置下载的文件名
        document.body.appendChild(link)
        link.click() // 模拟点击链接，‌开始下载
        document.body.removeChild(link) // 下载完成后移除a标签
    },
} 

export default tools